<!-- 输入框  文本、数值-->
<template>
  <el-date-picker
    v-model="editInput"
    class="cashierdiary--inpout"
    :placeholder="inputTip"
    value-format="yyyy-MM-dd"
    type="date"
    >
  </el-date-picker>
</template>

<script>
  export default {
    props:{
      inputTip:{
        type:String,
        default:"请输入数值内容"
      },
      value:[Date,String]
    },
    data() {
      return {
      }
    },
    computed:{
      editInput:{
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    },
    methods:{

    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../../assets/css/cashierdiary/input.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/c-date.vue